module.exports = __webpack_public_path__ + "img/es-round.57fb4b63.svg";